import { createUseStyles } from 'react-jss';
import { BottomSheetTypes, TitleAlignments } from '../types/index.js';
import { scrollbar } from '../../../../foundation/styleHelpers/scrollbar/scrollbar/index.js';
import { ControlTextColors } from '../../../../foundation/colors/controlTextColors/controlTextColors/index.js';
import { Spacings } from '../../../../foundation/spacings/spacings/index.js';
import { CornerRadius } from '../../../../foundation/cornerRadius/cornerRadius/index.js';
import { BackgroundColors } from '../../../../foundation/colors/backgroundColors/backgroundColors/index.js';
import { Easing } from '../../../../foundation/easing/easing/index.js';
import { Timings } from '../../../../foundation/timings/timings/index.js';

// @ts-nocheck //this file will be deleted
const useStyles = createUseStyles({
    '@global': {
        body: {
            '--sat': 'env(safe-area-inset-top, 0px)',
            '&[data-open]': {
                overflow: 'hidden',
            },
        },
    },
    root: ({ animation, zIndex, isSafeAreaExist }) => ({
        transition: `opacity ${Timings.default} ${Easing.ease}`,
        position: 'fixed',
        backgroundColor: BackgroundColors.transparent,
        left: Spacings.s0,
        opacity: !animation && 0,
        right: animation && Spacings.s0,
        zIndex: zIndex || null,
        pointerEvents: !animation && 'none',
        '@supports (top: env(safe-area-inset-top))': {
            top: isSafeAreaExist ? 'env(safe-area-inset-top, 0)' : 0,
        },
        '@supports (bottom: env(safe-area-inset-bottom))': {
            bottom: isSafeAreaExist ? 'env(safe-area-inset-bottom, 0)' : 0,
        },
    }),
    bottomSheet: ({ animation, transform, isSmooth, viewPortHeight, isFullWidth, zIndex, isSafeAreaExist, }) => ({
        '--button-size': '44px',
        position: 'fixed',
        transform: animation ? (`translate(-50%, ${viewPortHeight - transform}px)`) : `translate(-50%, ${viewPortHeight}px)`,
        height: animation && (viewPortHeight === transform
            ? `calc(${transform}px - (env(safe-area-inset-top) + env(safe-area-inset-bottom))` : viewPortHeight),
        backgroundColor: BackgroundColors.base,
        transition: `transform ${Timings.default} ${Easing.ease}`,
        margin: [Spacings.s0, 'auto'],
        display: 'flex',
        flexFlow: 'column',
        width: '100%',
        maxHeight: '100%',
        borderRadius: viewPortHeight !== transform ? CornerRadius.r12 : null,
        transitionProperty: 'max-height, transform, border-radius',
        transitionDuration: isSmooth ? Timings.default : 0,
        transitionTimingFunction: Easing.ease,
        maxWidth: !isFullWidth && 390,
        insetInlineStart: '50%',
        zIndex: zIndex || null,
        willChange: 'transform',
        bottom: isSafeAreaExist ? 'env(safe-area-inset-bottom, 0px)' : 0,
    }),
    header: {
        position: 'relative',
        display: 'grid',
        columnGap: Spacings.s4,
        minHeight: 44,
        alignItems: 'center',
        flexShrink: 0,
        textAlign: 'center',
        margin: [Spacings.s16, Spacings.s16, Spacings.s0, Spacings.s16],
        gridTemplateColumns: ({ startIcon }) => `${startIcon ? 'var(--button-size)' : 0} auto var(--button-size)`,
        direction: ({ reverseIcons }) => reverseIcons && 'rtl',
    },
    title: {
        marginInlineStart: ({ startIcon, titleAlignment }) => (!startIcon && titleAlignment === TitleAlignments.Center) && 'var(--button-size)',
        textAlign: ({ titleAlignment }) => titleAlignment,
        maxWidth: '100%',
        gridColumnStart: 2,
        gridColumnEnd: 3,
    },
    swipe: {
        display: 'grid',
        height: 24,
        placeContent: 'center',
        flexShrink: 0,
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            width: '100%',
            height: 65,
            backgroundColor: 'transparent',
            transform: 'translateY(-20px)',
            zIndex: 10,
        },
        '&::after': {
            content: '""',
            width: 44,
            height: 4,
            backgroundColor: BackgroundColors.tint3,
            borderRadius: CornerRadius.r4,
        },
    },
    button: {
        justifySelf: 'end',
    },
    closeButton: {
        gridColumnStart: 3,
        gridColumnEnd: 4,
    },
    actionButton: {
        gridColumnStart: 1,
        gridColumnEnd: 2,
    },
    content: {
        overflow: 'auto',
        flexGrow: 1,
        touchAction: 'pan-y',
        margin: ({ hideHeader, hideHandleLine }) => ((hideHeader && hideHandleLine) ? Spacings.s16 : `${Spacings.s12} ${Spacings.s16} ${Spacings.s16} ${Spacings.s16}`),
        maxHeight: ({ headerHeight, type, customHeight, isExpanded, }) => (type === BottomSheetTypes.Static && !isExpanded) && `calc(${customHeight}px - ${headerHeight}px - ${Spacings.s16} - ${Spacings.s16})`,
        ...scrollbar(),
    },
    icon: {
        '& path': {
            fill: ControlTextColors.default,
        },
    },
}, {
    name: 'bottom-sheet',
});

export { useStyles };
